module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_jp.4219f732d1485e8b6a54b0a585c43a2a.png";